<template>
  <div class="w-full flex flex-row md:cursor-pointer justify-between gap-4 items-center md:py-3 md:px-4 md:rounded-lg md:bg-white"
       :class="[bgColor && bgColor !== 'bg-white' ? `${bgColor} py-3 px-4 rounded-lg` : 'py-2', disabled ? 'pointer-events-none' : '']"
       @click="onClick">
    <div class="flex flex-col w-full">
      <div class="flex gap-2 justify-start">
        <span class="font-medium">{{activeTitle && toggleValue ? activeTitle : title }}</span>
        <span v-if="isNew" class="w-max bg-yellow-100 text-yellow-600 px-2 text-sm rounded-xl flex-none h-min">
          חדש
        </span>
      </div>
      <span class="text-xs text-gray-400 text-pretty">{{ description }}</span>
    </div>
    <ToggleSwitch
      v-model="toggleValue"
      class="flex-none"
      @change="onChange"
      :disabled="disabled"
      @click.stop />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ToggleSwitch from 'primevue/toggleswitch';

const props = defineProps({
  title: {
    required: true,
    type: String
  },
  description: {
    default: '',
    required: false,
    type: String
  },
  status: {
    required: true,
    type: Boolean
  },
  isNew: {
    required: false,
    type: Boolean,
    default: false
  },
  activeTitle: {
    required: false,
    type: String,
    default: ''
  },
  bgColor: {
    required: false,
    type: String,
    default: 'bg-white'
  },
  disabled: {
    required: false,
    type: Boolean,
    default: false
  },

});
const emit = defineEmits(['valueChanged']);

const onChange = () => {
  emit('valueChanged', toggleValue.value);
};

const onClick = () => {
  if (props.disabled) return;
  toggleValue.value = !toggleValue.value;
  onChange();
};

const toggleValue = ref<boolean>(props.status);
</script>

